export function initGalerieFullscreen({
  hoverTrigger,
  fullscreenBtn,
  extraButtons = [],
  iconExpand,
  iconCompress,
  headerEl,
  galerieSection,
  navLinks,
  getCurrentTab,
}) {
  let fullscreenActive = false;
  let hideHeaderTimer = null;
  // Boutons posés à côté du plein écran (ex. aléatoire) : mêmes règles
  // d'apparition/disparition en plein écran.
  const cornerButtons = [fullscreenBtn, ...extraButtons];

  function setCornerButtonsVisible(visible) {
    cornerButtons.forEach((btn) => btn.classList.toggle('btn-visible', visible));
  }

  function updateFullscreenIcon() {
    iconExpand.hidden = fullscreenActive;
    iconCompress.hidden = !fullscreenActive;
  }

  function enterGalerieFullscreen() {
    fullscreenActive = true;
    document.body.classList.add('galerie-fullscreen');
    updateFullscreenIcon();
  }

  function exitGalerieFullscreen() {
    fullscreenActive = false;
    clearTimeout(hideHeaderTimer);
    document.body.classList.remove('galerie-fullscreen');
    headerEl.classList.remove('header--visible');
    setCornerButtonsVisible(false);
    updateFullscreenIcon();
  }

  function showHeader() {
    clearTimeout(hideHeaderTimer);
    headerEl.classList.add('header--visible');
    setCornerButtonsVisible(true);
  }

  function scheduleHideHeader() {
    clearTimeout(hideHeaderTimer);
    hideHeaderTimer = setTimeout(() => {
      headerEl.classList.remove('header--visible');
      setCornerButtonsVisible(false);
    }, 800);
  }

  // mouseleave sur la zone de déclenchement aussi : si la souris redescend
  // sans être passée dans le header, rien d'autre ne le refermerait. Même
  // logique sur les boutons du coin (comme sur Sillage) pour pouvoir les
  // utiliser en plein écran.
  hoverTrigger.addEventListener('mouseenter', showHeader);
  hoverTrigger.addEventListener('mouseleave', scheduleHideHeader);
  headerEl.addEventListener('mouseleave', scheduleHideHeader);
  headerEl.addEventListener('mouseenter', showHeader);
  cornerButtons.forEach((btn) => {
    btn.addEventListener('mouseenter', () => { if (fullscreenActive) showHeader(); });
    btn.addEventListener('mouseleave', () => { if (fullscreenActive) scheduleHideHeader(); });
  });

  fullscreenBtn.addEventListener('click', () => {
    if (fullscreenActive) exitGalerieFullscreen();
    else enterGalerieFullscreen();
  });

  galerieSection.addEventListener('dblclick', () => {
    if (getCurrentTab() !== 'galerie') return;
    if (fullscreenActive) exitGalerieFullscreen();
    else enterGalerieFullscreen();
  });

  document.addEventListener('keydown', (event) => {
    if (getCurrentTab() !== 'galerie') return;
    if (event.key === 'Escape' && fullscreenActive) exitGalerieFullscreen();
    else if ((event.key === 'f' || event.key === 'F') && !fullscreenActive) enterGalerieFullscreen();
  });

  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      if (fullscreenActive && link.dataset.tab !== 'galerie') exitGalerieFullscreen();
    });
  });
}
